export enum UserRole {
    ADMIN = 'cca87dc0-f87d-4eb7-a546-e600123492b9',
    USER = '28666e0e-f3c2-4818-bf55-7f31a53240bf',
    SYSTEM_ADMIN = '94e5d61e-7f90-477b-9a0f-9d5ff6a56234'
}

export const allRoles = Object.values(UserRole);
export const adminRoles = [UserRole.ADMIN, UserRole.SYSTEM_ADMIN];
export const systemAdminRole = [UserRole.SYSTEM_ADMIN];
